import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';
import { moreMenuItems, MoreMenuSection } from '../menu';
import { HttpErrorResponse } from '@angular/common/http';
import { ThirdPartyService } from '../../third-party.service';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { Subscription } from 'rxjs';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';

@Component({
  selector: 'app-service-near-more-menulist',
  templateUrl: './service-near-more-menulist.component.html',
  styleUrls: ['./service-near-more-menulist.component.scss']
})
export class ServiceNearMoreMenulistComponent implements OnInit, OnDestroy {
  menuListItems: MoreMenuSection[] = moreMenuItems;
  isShowDeleteAllPopUp: boolean = false;
  isShowDltMsg: boolean = false;
  suscriptionFeatures: any = {};
  private subscriptionsToUnsubscribe = new Subscription();

  constructor(
    public layoutService: LayoutService,
    public configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
    public thirdPartyService: ThirdPartyService,
    public adminService: AdminService,
    public privilegeService: PrivilegesService,
    private subscriptionsService: SubscriptionsService,
  ) { }

  ngOnInit(): void {
    this.populateToolbarData();
    const admin = this.adminService.getLoginDetails();

    // Subscribe to subscription features updates from service
    const subsSub = this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features) {
        this.suscriptionFeatures = features;
        this.setSubscriptionFeatures();
      }
    });
    this.subscriptionsToUnsubscribe.add(subsSub);

    // profile instead of acc info for non admin users
    const accountSection = this.menuListItems.find(sec => sec.id === 'account');
    if (accountSection) {
      const accountInfoItem = accountSection.items.find(item => item.id === 'accinfo');
      if (accountInfoItem) {
        if (admin?.UserType !== "admin") {
          accountInfoItem.hidden = true;
        } else {
          accountInfoItem.hidden = false;
        }
      }
    }

    const usersManagement = this.menuListItems.find(
      item => item.id === 'user'
    );
    const userItemList = usersManagement?.items || [];
    const addUserItem = userItemList.find(item => item.id === 'adduser');
    const listUserItem = userItemList.find(item => item.id === 'userlist');

    if (addUserItem && !this.privilegeService.getServicenearPrivilege('addUser', true)) {
      addUserItem.disabled = true;
    }
    if (listUserItem && !this.privilegeService.getServicenearPrivilege('listUser', true)) {
      listUserItem.disabled = true;
    }

    const settingsItem = accountSection?.items.find(
      item => item.id === 'servicenearsettings'
    );
    
    if (settingsItem && this.thirdPartyService.getIncomingApps()?.includes('Servicenear')) {
      settingsItem.hidden = false;
    }
  }

  ngOnDestroy(): void {
    this.subscriptionsToUnsubscribe.unsubscribe();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Menu',
    });

    this.layoutService.setNavbarButtons([]);
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
  }

  public gotoPage(path) {
    if (path === 'logout') {
      this.logOutClicked()
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate([path], { queryParams: currentParams });
    }
  }

  public setSubscriptionFeatures(){
    const usersManagement = this.menuListItems.find(
      item => item.id === 'user'
    );
    const userItemList = usersManagement?.items || [];
    const addUserItem = userItemList.find(item => item.id === 'adduser');
    const listUserItem = userItemList.find(item => item.id === 'userlist');
    
    if(addUserItem && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.user?.show){
        addUserItem.hidden = false;
      }else{
        addUserItem.hidden = true;
      }
      if(this.suscriptionFeatures?.user?.disable){
        addUserItem.disabled = true;
      }else{
        addUserItem.disabled = false;
      }

      if(this.suscriptionFeatures?.user === undefined){
        addUserItem.hidden = false;
        addUserItem.disabled = true;
      }
    }
    if(listUserItem && this.suscriptionFeatures){
      if(this.suscriptionFeatures?.user?.show){
        listUserItem.hidden = false;
      }else{
        listUserItem.hidden = true;
      }
      if(this.suscriptionFeatures?.user?.disable){
        listUserItem.disabled = true;
      }else{
        listUserItem.disabled = false;
      }

      if(this.suscriptionFeatures?.user === undefined){
        listUserItem.hidden = false;
        listUserItem.disabled = true;
      }
    }
  }
}
